import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import NewsListedByCategoryContent from 'src/components/News/NewsListedByCategoryContent/NewsListedByCategoryContent'
import Footer from 'src/components/Footer/Footer'

const NewsListedByCategoryPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <NewsListedByCategoryContent />
      <Footer />
    </>
  )
}

export default NewsListedByCategoryPage
